export default __webpack_public_path__ + "chat_head.cd8043b8.svg";